import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LayoutContext } from '../../../contexts/layout.context';

import Head from '../../../components/Head/Head';
import LastNameForm from '../../../components/Profile/Edit/LastNameForm/LastNameForm';
import actions from '../../../store/actions';
import { useDispatch } from 'react-redux';

const EditLastName = () => {
  const { setLayout } = useContext(LayoutContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = 'Зміна | New Brain';
    setLayout({ page: 'Зміна' });
  }, [setLayout]);

  const goBack = () => {
    navigate('/profile');
    dispatch(actions.profile.profileError({}));
  };

  return (
    <div className="profile container">
      <Head textHead='Зміна прізвища' goBack={goBack} />
      <div className="profile__content">
        <LastNameForm />
      </div>
    </div>
  );
};

export default EditLastName;